import { useModeConsumer } from "../custom/useMode";

function Iframe({ disable, url, handleLodingState }) {
  const mode = useModeConsumer();

  return (
    <iframe
      className={`h-100 ${mode.previewMode} ${disable ? "d-none " : ""}`}
      src={url}
      title="W3Schools Free Online Web Tutorials"
      onLoad={handleLodingState}
    ></iframe>
  );
}

export default Iframe;
